import React from "react";
import { Link, useLocation, useParams } from "react-router-dom";
import { useIsMobile } from "../primitives/useIsMobile";

const STATIC_LABELS = {
  "/dashboard": [{ label: "Dashboard" }],
  "/jornada": [{ label: "Mi jornada" }],
  "/solicitudes": [{ label: "Solicitudes" }],
  "/mis-solicitudes": [{ label: "Mis solicitudes" }],
  "/calendario": [{ label: "Calendario" }],
  "/empleados": [{ label: "Empleados" }],
  "/equipos": [{ label: "Equipos" }],
  "/contratos": [{ label: "Contratos" }],
  "/documentos": [{ label: "Documentos" }],
  "/reportes": [{ label: "Reportes" }],
  "/configuracion": [{ label: "Configuración" }],
};

function crumbsFor(pathname) {
  if (STATIC_LABELS[pathname]) return STATIC_LABELS[pathname];
  // Detalles dinámicos
  if (pathname.startsWith("/empleados/")) {
    return [
      { label: "Empleados", to: "/empleados" },
      { label: "Ficha" },
    ];
  }
  if (pathname.startsWith("/solicitudes/")) {
    return [
      { label: "Solicitudes", to: "/solicitudes" },
      { label: "Detalle" },
    ];
  }
  return [{ label: "Inicio" }];
}

export function Breadcrumbs() {
  const location = useLocation();
  const isMobile = useIsMobile();
  useParams();
  let items = crumbsFor(location.pathname);
  // En mobile mostramos solo el último segmento — los padres se pueden
  // alcanzar con el botón "atrás" del navegador / hamburger.
  if (isMobile && items.length > 1) {
    items = [items[items.length - 1]];
  }
  return (
    <nav
      aria-label="Breadcrumb"
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        color: "var(--kr-fg-muted)",
        fontSize: 13,
        minWidth: 0,
        overflow: "hidden",
      }}
    >
      {items.map((c, i) => {
        const last = i === items.length - 1;
        const content = (
          <span
            style={{
              color: last ? "var(--kr-fg-strong)" : "var(--kr-fg-muted)",
              fontWeight: last ? 600 : 400,
              whiteSpace: "nowrap",
            }}
          >
            {c.label}
          </span>
        );
        return (
          <React.Fragment key={i}>
            {i > 0 && <span style={{ color: "var(--kr-fg-subtle)" }}>/</span>}
            {c.to && !last ? (
              <Link to={c.to} style={{ textDecoration: "none" }}>
                {content}
              </Link>
            ) : (
              content
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}

export default Breadcrumbs;
